"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/es7/reflect");
class AclCollection {
    // mapped indecies
    // resources_map: Map<string, any> = null;
    // roles_map: Map<string, any> = null;
    constructor(id, resources, roles) {
        // identifier
        this.id = '';
        // roles
        this.roles = null;
        // resources
        this.resources = null;
        // defaults
        this.defaults = null;
        // create a map of all entries
        this.resources = new Map();
        this.roles = new Map();
        this.defaults = new Map();
        // identifier for this collection
        this.id = id;
        // if resources are passed in, process them
        if (resources) {
            this.createResources(resources);
        }
        // if roles are passed in, process them
        if (roles) {
            this.createRoles(roles);
        }
    }
    createRoles(list) {
        for (var i = 0, len = list.length; i < len; i++) {
            this.createRole(list[i]);
        }
    }
    createRole(element) {
        if (element.default_for) {
            this.defaults.set(element.id, element.default_for);
        }
        this.roles.set(element.id, new AclItem(element));
    }
    createResources(list) {
        for (var i = 0, len = list.length; i < len; i++) {
            this.createResource(list[i]);
        }
    }
    createResource(element) {
        this.resources.set(element.id, new AclItem(element));
    }
}
exports.AclCollection = AclCollection;
class AclItem {
    constructor(obj) {
        // identifier
        this.id = '';
        // features
        this.features = null;
        // group
        this.group = '';
        //can
        this.can = null;
        this.but_can = null;
        // cannot
        this.cannot = null;
        this.but_cannot = null;
        // is can first? (true or false) checks in what order the can and cannot's came in
        this.canRulesOrder = -1;
        // default for anything?
        this.default_for = null;
        let n = -1;
        // we loop through the properties because order is significant
        for (var prop in obj) {
            // just to make sure the property is not something else (shouldn't be needed, but we like to be safe)
            if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                // just copy over the properties
                switch (prop) {
                    case 'id':
                        this.id = obj.id;
                        break;
                    case 'default_for':
                        this.default_for = obj.default_for;
                        break;
                    case 'features':
                        this.features = obj.features;
                        break;
                    case 'group':
                        this.group = obj.group;
                        break;
                    case 'can':
                        this.can = obj.can;
                        n++;
                        this.canRulesOrder = n;
                        break;
                    case 'but_can':
                        this.but_can = obj.but_can;
                        n++;
                        break;
                    case 'cannot':
                        this.cannot = obj.cannot;
                        n++;
                        break;
                    case 'but_cannot':
                        this.but_cannot = obj.but_cannot;
                        n++;
                        break;
                    default: break;
                }
            }
        }
    }
    // return this object for streaming (JSON object)
    getItemObj() {
        const ret = {
            'id': this.id
        };
        // poor hacking, needs refactoring into maping and callbacks
        if (this.default_for) {
            ret['default_for'] = this.default_for;
        }
        if (this.features) {
            ret['features'] = this.features;
        }
        if (this.group) {
            ret['group'] = this.group;
        }
        if (this.canRulesOrder != -1 && this.canRulesOrder == 0) {
            if (this.can) {
                ret['can'] = this.can;
            }
            if (this.cannot) {
                ret['cannot'] = this.cannot;
            }
            if (this.but_can) {
                ret['but_can'] = this.but_can;
            }
            if (this.but_cannot) {
                ret['but_cannot'] = this.but_cannot;
            }
        }
        else {
            if (this.cannot) {
                ret['cannot'] = this.cannot;
            }
            if (this.can) {
                ret['can'] = this.can;
            }
            if (this.but_cannot) {
                ret['but_cannot'] = this.but_cannot;
            }
            if (this.but_can) {
                ret['but_can'] = this.but_can;
            }
        }
        // console.log ( '!!!', this.id, this.canRulesOrder, ret );
        return ret;
    }
}
exports.AclItem = AclItem;
